import React from "react";
import { Participant as ParticipantType } from "twilio-video";
import { BiVideoOff } from "react-icons/bi";
import { Box } from "@chakra-ui/layout";

import colors from "theme/foundations/colors.style";
import { usePublications } from "hooks/session";
import { Callback } from "types";
import Publication from "./Publication";

interface ParticipantProps {
  participant: ParticipantType;
  isLocalParticipant?: boolean;
  enableScreenShare?: boolean;
  onClick?: Callback;
}

const Participant: React.FC<ParticipantProps> = ({
  participant,
  isLocalParticipant,
  enableScreenShare,
  onClick
}: ParticipantProps) => {
  const publications = usePublications(participant);

  const videoPublication = publications.find(p =>
    p.trackName.includes("camera")
  );

  const isVideoEnabled = Boolean(videoPublication);

  let filteredPublications;

  if (
    enableScreenShare &&
    publications.some(p => p.trackName.includes("screen"))
  ) {
    filteredPublications = publications.filter(
      p => !p.trackName.includes("camera")
    );
  } else {
    filteredPublications = publications.filter(
      p => !p.trackName.includes("screen")
    );
  }

  return (
    <Box
      borderRadius="10px"
      overflow="hidden"
      position="relative"
      height="full"
      onClick={onClick}
    >
      {!isVideoEnabled && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          background={colors.black}
          height="full"
        >
          <BiVideoOff />
        </Box>
      )}
      {filteredPublications.map(p => (
        <Publication
          key={p.kind}
          publication={p}
          isLocal={isLocalParticipant}
        />
      ))}
      <Box
        bgColor={colors.blueAlpha[600]}
        borderRadius="10px"
        bottom="2.5rem"
        color={colors.white}
        fontSize="small"
        left="0.4rem"
        maxWidth="fit-content"
        mb="-2.2rem"
        padding="0.5rem"
        position="relative"
      >
        {participant?.identity}
      </Box>
    </Box>
  );
};

export default Participant;
